import React from 'react';
import PropTypes from 'prop-types';
import url from 'url';
import Redirect from '../../../../common/components/Redirect';

const LoginRedirect = ({ returnUrl, message }) => {
  const loginUrl = url.parse(window.location.href);
  loginUrl.pathname = '/auth/login';
  // url.format prefers a pre-existing `search` string over `query`, so it
  // has to be cleared or the current page's own query string (e.g. the
  // onboarding email/memid) leaks onto /auth/login instead of returnUrl/message
  loginUrl.search = null;
  loginUrl.query = returnUrl ? { returnUrl, message } : null;

  return <Redirect external to={url.format(loginUrl)} />;
};

LoginRedirect.propTypes = {
  returnUrl: PropTypes.string,
  message: PropTypes.string,
};

export default LoginRedirect;



// WEBPACK FOOTER //
// ./src/App/account/components/LoginRedirect/index.js